var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"height":"5","color":_vm.barColor,"background-color":_vm.backgroundColor,"value":_vm.barValue}})}
var staticRenderFns = []

export { render, staticRenderFns }